import { render } from "./AcademicCalendarView.vue?vue&type=template&id=04b87ad0"
import script from "./AcademicCalendarView.vue?vue&type=script&lang=js"
export * from "./AcademicCalendarView.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__